import React from 'react';
const ArrowDown = ({ color = 'white' }) => {
    return (React.createElement("svg", { width: "10", height: "6", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 5.30284L0.717493 1.1417L1.17538 0.69679L4.65196 4.06748L5 4.40492L5.34804 4.06748L8.82462 0.69679L9.28251 1.1417L5 5.30284Z", fill: "white", stroke: color })));
};
export default ArrowDown;
